module.exports = __webpack_public_path__ + "img/apple-itunes.ad67a277.svg";